import Lottie from 'lottie-react';

import deliveryAnimation from './animations/delivery.json';

import './loader.component.scss';

export const BuyNowLoader = () => {
  return (
    <div>
      <div className="col-xs-12 col-loading co-z-100">
        <div className="box-icon">
          <div>
            <Lottie
              animationData={deliveryAnimation}
              loop={true}
              autoplay={true}
            />
            <p className="text-center">
              <b>
                Estamos validando tu dirección para ofrecerte una fecha de
                entrega.
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
